import React, { Component } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';

function childFactory(child, location) {
  return React.cloneElement(child, {
    classNames:
      (location.state && location.state.transitionDirection) ||
      child.props.classNames
  });
}

class AnimateRoutes extends Component {
  childFactoryCreator = child => {
    const { location } = this.props;

    return childFactory(child, location);
  };

  render() {
    const { children, location } = this.props;
    const backClass = location.state
      ? ' ' + location.state.transitionDirection
      : '';

    return (
      <div className={`animate-routes-container${backClass}`}>
        <TransitionGroup childFactory={this.childFactoryCreator}>
          <CSSTransition key={location.key} classNames="slide" timeout={500}>
            {children}
          </CSSTransition>
        </TransitionGroup>
      </div>
    );
  }
}

AnimateRoutes.propTypes = {
  location: PropTypes.object.isRequired,
  className: PropTypes.string,
  goingBack: PropTypes.bool.isRequired
};

export default AnimateRoutes;
